// Event names saved to `alertbox_dont_show_next_time` when a user agrees to or
// declines the terms. When the terms change, add new event names so every user
// is asked again and their new answer is stored as a new event.
export const LOADSHIFT_TERMS_AGREED_EVENT = 'agreed-to-loadshift-terms-2026-09';
export const LOADSHIFT_TERMS_DECLINED_EVENT =
  'declined-loadshift-terms-2026-09';

// Set by `AdminLoginAsCookie` (PHP) to the user ID while staff are logged in
// as that user
export const ADMIN_LOGIN_AS_COOKIE = 'GETAFREE_ADMIN_LOGIN_AS';

export enum LoadshiftTermsResponse {
  AGREED = 'agreed',
  DECLINED = 'declined',
}

export interface LoadshiftTermsModalResult {
  readonly response: LoadshiftTermsResponse;
  /** False if the response failed to save, so the user is asked again later */
  readonly isRecorded: boolean;
}

export const EXCLUDED_URLS: readonly string[] = [
  '/about/terms',
  '/about/privacy',
  '/terms-of-use',
  '/privacy-policy',
  '/info/codeofconduct',
  '/new-account',
  '/new-carrier',
  '/complete-your-profile',
  '/post-load',
];
